import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface User {
  id?: string;
  username: string;
  email: string;
  fullName: string;
  role: string;
  createdAt?: string;
  lastLogin?: string;
  isActive: boolean;
  profilePictureUrl?: string;
}

export class UsersRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/users');
  }

  getAll(): Promise<User[]> {
    return this.get<User[]>(``);
  }

  getById(id: string): Promise<User> {
    return this.get<User>(`/${id}`);
  }

  getByEmail(email: string): Promise<User> {
    return this.get<User>(`/info/${encodeURIComponent(btoa(email))}`);
  }

  changePassword(id: string, newPassword: string): Promise<void> {
    return this.put<void>(`/${id}/password`, newPassword);
  }

  // Admin endpoints (see API controller: [HttpGet("admin")], [HttpGet("{id}/admin")])
  getAllAdmin(): Promise<User[]> {
    return this.get<User[]>(`/admin`);
  }

  getByIdAdmin(id: string): Promise<User> {
    return this.get<User>(`/${id}/admin`);
  }

  createAdmin(user: User): Promise<User> {
    return this.post<User>(`/admin`, user);
  }

  updateAdmin(id: string, user: User): Promise<void> {
    return this.put<void>(`/${id}/admin`, user);
  }

  deleteAdmin(id: string): Promise<void> {
    return super.delete(`/${id}/admin`);
  }
}
